// Navbar.jsx
import { useState } from "react";
import { Phone, Menu } from "lucide-react";
import DesktopNav from "./DesktopNav";
import MobileDrawer from "./MobileDrawer";

export default function Navbar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <nav className="bg-black text-white px-6 py-2">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <a href="/" className="flex items-center gap-2">
            <img
              src="/assets/logo.png"
              className="w-24"
              alt="Hawkins & Brooks Logo"
            />
            <span className="font-bold uppercase">Hawkins & Brooks</span>
          </a>

          <DesktopNav />

          <div className="flex gap-2">
            <a
              href="tel:+919217468906"
              className="border px-3 py-1 rounded text-sm flex gap-1 items-center hover:bg-yellow-500 hover:text-black transition-colors"
            >
              <Phone size={14} /> Call
            </a>
            <button
              onClick={() => setIsDrawerOpen(true)}
              className="lg:hidden p-1"
            >
              <Menu size={20} />
            </button>
          </div>
        </div>
      </nav>

      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
}
